export enum TipoProcessamentoRecorrenciaEnum {
    ApenasEsta = 1,
    Proximas = 2,
    TodasEmAberto = 3
}
